import { render, staticRenderFns } from "./PedidorExportacion.vue?vue&type=template&id=4a5cead2"
import script from "./PedidorExportacion.vue?vue&type=script&lang=js"
export * from "./PedidorExportacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports